<template>
	<div class="row">
		<div class="col-md-6 pt-3 pb-3">
			<assets-composition :inline="false" :size="203" :selectable="true" :onSelect="this.onSelect" />
		</div>
		<div class="col-md-6 pt-3">
			<h4>{{ heading }}</h4>
      <Loading v-if="loading" class="mt-5 pt-3"/>
			<data-grid  v-else :items="list" :columns="columns" :smallTable="true" :showDetail="false">
				<template slot="name" slot-scope="{ item }">
					{{ item.name }}
				</template>
				<template slot="sumEUR" slot-scope="{ item }">
					{{ item.sumEUR | number }} {{ item.currencyEUR }}
				</template>
				<template slot="ratio" slot-scope="{ item }">
					{{ (item.ratio * 100) | number(3) }} %
				</template>
			</data-grid>
		</div>
	</div>
</template>

<script>
import AssetsComposition from "../../../components/AssetsComposition";
import DataGrid from "../../../components/DataGrid";
import Loading from "../../../components/Loading";

export default {
	name: "AssetsCompositionFull",
	components: { AssetsComposition, DataGrid, Loading },
    computed: {
		portfolio() {
			return this.$store.state.portfolio.selected;
		},
    loading() {
        return this.$store.state.assets.loadingCompositionDetail;
    },
		list() {
			return this.$store.state.assets.compositionDetail;
		},
		heading() {
			return this.$store.state.assets.compositionDetailHeading;
		},
	},
	watch: {
		portfolio: {
            deep: true,
            handler() {
                this.loadData();
            },
		},
	},
	methods: {
		onSelect(assetType, assetTypeName) {
			this.setState({ assetType, assetTypeName });
			this.loadData();
		},
		setState(state) {
			this.state = { ...this.state, ...state };
		},
		loadData() {
			const { assetType, assetTypeName } = this.state;
			if (assetType) {
				this.$store.dispatch("assets/assetCompositionDetail", { assetType, assetTypeName, portfolio: this.portfolio });
			}
		},
	},
	data() {
		return {
			state: {
				assetType: null,
				assetTypeName: ""
			},
			columns: [
				{
					name: "Aktívum",
					slug: "name",
				},
				{
					name: "Objem v ref. mene",
					slug: "sumEUR",
				},
				{
					name: "Podiel",
					slug: "ratio",
				},
			],
		};
	},
};
</script>

<style scoped></style>
